<template>
    <div class="product_list_vtwo">
        <section class="category_banner_custom" v-if="banner_image">
            <img :src="banner_image" alt=" " class="" />
        </section>

        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!--<li
                            class="breadcrumb-item"
                            v-if="
                                !listConfig.searchKeyword &&
                                $route.params.product_type != 'brand'
                            "
                        >
                            <router-link :to="{ path: productTypePath }">
                                {{ routeSlug | capitalize }}
                            </router-link>
                        </li>
                         <li class="breadcrumb-item active" aria-current="page">
                            {{
                                CategoryBreadcrumbs(selected_category)
                                    | capitalize
                            }}
                        </li>
                        <li
                            v-if="$route.params.second_filter_name"
                            class="breadcrumb-item active"
                            aria-current="page"
                        >
                            {{ $route.params.second_filter_name | capitalize }}
                        </li> -->
                        <li
                            v-for="(breadcrumb, index) in breadcrumb_names"
                            :to="breadcrumb_urls[index]"
                            :key="index"
                            class="breadcrumb-item"
                            aria-current="page"
                        >
                            <router-link :to="breadcrumb_urls[index]">{{
                                breadcrumb
                            }}</router-link>
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="cmn-section item-category-list pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40">
                                    {{
                                        CategoryTitle(
                                            breadcrumb_names[
                                                breadcrumb_names.length - 1
                                            ]
                                        ) | capitalize
                                    }}
                                </span>
                            </h1>
                            <h3 class="sub_heading1 text-center mt_6 mb-0">
                                Our Best Selling Items
                            </h3>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="float-right short_by">
                            <div class="select_option sec_opt">
                                <label>Sort by</label>
                                <fieldset>
                                    <v-select
                                        label="label"
                                        :reduce="(sorting) => sorting.value"
                                        v-model="listConfig.sorting"
                                        :options="sorting_array"
                                        :placeholder="'sort by'"
                                        @input="getProducts(true)"
                                    ></v-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 apparel">
                        <div
                            class="row"
                            v-if="$route.params.product_type == '4'"
                        >
                            <div
                                class="col-md-12 col-lg-12 col-xl-12 mt-5 mt-lg-0"
                            >
                                <div class="row">
                                    <div
                                        class="col-md-6 col-lg-6 col-xl-3"
                                        v-for="(product, key) in product_list"
                                        :key="'product' + key"
                                    >
                                        <div class="product promodetails">
                                            <div
                                                class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                            >
                                                <router-link
                                                    :to="{
                                                        name: 'product_details_new',
                                                        params: {
                                                            id_of_product:
                                                                product.id
                                                        }
                                                    }"
                                                >
                                                    <img
                                                        :src="
                                                            product.product_default_image
                                                        "
                                                    />
                                                    <!-- <DisplayProductImage :product="product" :classValue="'img-fluid'" /> -->
                                                </router-link>
                                                <div class="">
                                                    <DiscountOffer
                                                        :product="product"
                                                    />
                                                    <div
                                                        class="offer-badge font_size_20 text_light_grey_2 mt_40"
                                                    >
                                                        Coupon Code
                                                    </div>
                                                </div>

                                                <div class="absolute-tittle">
                                                    <div
                                                        class="font_size_24 text-uppercase font-weight-bold"
                                                    >
                                                        get code
                                                    </div>
                                                    <div class="font_size_20">
                                                        {{
                                                            product.name
                                                                | capitalize
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-12 col-xl-12 align-self-center text-center"
                                        v-show="
                                            product_list.length < 1 &&
                                            !isBusy &&
                                            hasSearched
                                        "
                                    >
                                        <div class="product mb-0">
                                            <h3>No results found.</h3>
                                        </div>
                                    </div>
                                </div>
                                <b-pagination
                                    v-show="category_length > itemsPerPage"
                                    v-model="currentPage"
                                    :total-rows="category_length"
                                    :per-page="itemsPerPage"
                                    class="imprint_pagination"
                                ></b-pagination>
                                <!-- <VPagination v-show="category_length > itemsPerPage" :pages="pages" :currentPage.sync="currentPage" /> -->
                            </div>
                        </div>
                        <div class="row" v-else>
                            <!-- Side Bar Start Here -->
                            <div
                                class="col-md-12 col-lg-4 col-xl-2"
                                v-if="
                                    !listConfig.searchKeyword ||
                                    product_list.length > 0
                                "
                            >
                                <div
                                    class="side_bar filter"
                                    v-if="
                                        selected_category ||
                                        (brand_list && brand_list.length > 0) ||
                                        (styles_list &&
                                            styles_list.length > 0) ||
                                        (color_shades_list &&
                                            color_shades_list.length > 0) ||
                                        (sizes_list && sizes_list.length > 0) ||
                                        (applied_filters &&
                                            applied_filters.length > 0)
                                    "
                                >
                                    <div class="categorys">
                                        <div
                                            class="accordion"
                                            id="accordionExample"
                                            v-if="selected_category"
                                        >
                                            <div
                                                v-if="
                                                    applied_filters.length > 0
                                                "
                                            >
                                                <div>
                                                    <button
                                                        class="category_link w-100 d-flex"
                                                        style="cursor: default"
                                                        type="button"
                                                    >
                                                        <span
                                                            >Applied
                                                            Facets</span
                                                        >
                                                    </button>
                                                </div>
                                                <div
                                                    class="category_checkbox_show"
                                                >
                                                    <div
                                                        class="category_checkbox"
                                                    >
                                                        <div
                                                            class="form-check pl_8 py_6"
                                                            v-for="(
                                                                filter, index
                                                            ) in applied_filters"
                                                            :key="index"
                                                        >
                                                            <label
                                                                class="checkbox_custom p-0 d-table"
                                                            >
                                                                <img
                                                                    @click="
                                                                        removeAppliedFilters(
                                                                            filter
                                                                        )
                                                                    "
                                                                    src="/maincss/images/cross_red_circle.png"
                                                                    width="15"
                                                                    class="mr-1"
                                                                />
                                                                <span
                                                                    style="
                                                                        cursor: default;
                                                                    "
                                                                    >{{
                                                                        filter.option_label
                                                                            | capitalize
                                                                    }}</span
                                                                >
                                                            </label>
                                                        </div>
                                                        <a
                                                            @click="
                                                                clearFilters(
                                                                    'all'
                                                                )
                                                            "
                                                            class="font_size_13 text-danger btn_link mt_14 pl_8"
                                                        >
                                                            Clear All
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- BRANDS -->
                                            <AttributeFilter
                                                id="Brands"
                                                name="Brands"
                                                index="Brands"
                                                type="brandIds"
                                                :active="true"
                                                :options="brand_list"
                                                :show-more-options="
                                                    isbrandShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore('isbrandShowMore')
                                                "
                                            />
                                            <!-- STYLES -->
                                            <AttributeFilter
                                                id="Styles"
                                                name="Styles"
                                                index="Styles"
                                                type="styles"
                                                :options="styles_list"
                                                :show-more-options="
                                                    isstylesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore('isstylesShowMore')
                                                "
                                            />
                                            <!-- COLOR SHADES -->
                                            <AttributeFilter
                                                id="ColorShades"
                                                name="Colors"
                                                index="ColorShades"
                                                type="colorShades"
                                                :storeKey="'name'"
                                                :options="color_shades_list"
                                                :show-more-options="
                                                    iscolorShadesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore(
                                                        'iscolorShadesShowMore'
                                                    )
                                                "
                                            />

                                            <!-- SIZES -->
                                            <AttributeFilter
                                                id="Sizes"
                                                name="Sizes"
                                                index="Sizes"
                                                type="sizeIds"
                                                :options="sizes_list"
                                                option-label="size"
                                                :show-more-options="
                                                    issizesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore('issizesShowMore')
                                                "
                                            />

                                            <!-- PRICES -->
                                            <!---
                                                <AttributeFilter 
                                                    id="Prices"
                                                    name="Prices" 
                                                    index="Prices"
                                                    type="priceRanges"
                                                    :options="prices"
                                                    :show-more-options="ispricesShowMore"
                                                    :config="listConfig"
                                                    @clearFilters="clearFilters"
                                                    @filterProducts="filterProducts"
                                                    @showMore="showMore('ispricesShowMore')"
                                                />
                                            -->

                                            <!-- ATTRIBUTES -->
                                            <div
                                                v-for="(
                                                    attribute, attribute_index
                                                ) in selected_category &&
                                                selected_category.Attributes
                                                    ? selected_category.Attributes
                                                    : []"
                                                :key="attribute_index"
                                                v-show="
                                                    selected_category &&
                                                    selected_category.Attributes
                                                "
                                            >
                                                <AttributeFilter
                                                    :id="`Attribute-${attribute.id}`"
                                                    :name="
                                                        attribute.attribute_name
                                                    "
                                                    :index="attribute_index"
                                                    :options="
                                                        attribute.AttributeOptions
                                                    "
                                                    :show-more-options="
                                                        attribute.show_more
                                                    "
                                                    :config="listConfig"
                                                    type="attribute_options"
                                                    option-label="category"
                                                    @clearFilters="clearFilters"
                                                    @filterProducts="
                                                        filterProducts
                                                    "
                                                    @showMore="
                                                        showMore(attribute)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Side Bar End Here -->
                            <div class="col-md-12 col-lg-8 col-xl-10">
                                <div class="row">
                                    <div
                                        class="col-md-6 col-lg-6 col-xl-3 product-custom-md-padding"
                                        data-aos="fade-up"
                                        data-aos-delay="100"
                                        data-aos-offset="100"
                                        v-for="(product, key) in product_list"
                                        :key="'product' + key"
                                    >
                                        <div class="product">
                                            <div
                                                :class="[
                                                    'product_image bg_primary_light_white py_30 position-relative test',
                                                    {
                                                        cap_category_images: shouldApplyCapCategoryClass(
                                                            product.category_id,
                                                            product.product_default_image
                                                        )
                                                    }
                                                ]"
                                            >
                                                <router-link
                                                    :to="{
                                                        name: 'product_details_new',
                                                        params: {
                                                            id_of_product:
                                                                product.id
                                                        }
                                                    }"
                                                >
                                                    <DiscountOffer
                                                        :product="product"
                                                    />
                                                    <img
                                                        class="img-fluid pro_img_fluid"
                                                        :alt="product.name"
                                                        :src="
                                                            product.product_default_image
                                                        "
                                                    />
                                                </router-link>
                                                <!-- <DisplayProductImage :product="product" :classValue="'img-fluid'" :color="product.default_color_id" />  -->

                                                <ProductBottomLinks
                                                    :product="product"
                                                    :ref="`bottom-links-${product.id}`"
                                                    @updateFavourites="
                                                        getAllFavoriteProducts
                                                    "
                                                />
                                            </div>
                                            <div class="product_content_main">
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h4 class="product-sku">
                                                        <router-link
                                                            :to="{
                                                                name: 'product_details_new',
                                                                params: {
                                                                    id_of_product:
                                                                        product.id
                                                                }
                                                            }"
                                                            >{{
                                                                product.product_number
                                                                    | capitalize
                                                            }}</router-link
                                                        >
                                                    </h4>
                                                    <router-link
                                                        :to="{
                                                            name: 'product_details_new',
                                                            params: {
                                                                id_of_product:
                                                                    product.id
                                                            }
                                                        }"
                                                    >
                                                        <h5
                                                            class="heading5 product_list_title"
                                                        >
                                                            {{
                                                                product.name
                                                                    | capitalize
                                                            }}
                                                        </h5>
                                                    </router-link>
                                                    <div
                                                        class="d-flex justify-content-center collapsed color_price"
                                                    >
                                                        <DisplayProductPrice
                                                            :product="product"
                                                        />
                                                        <DisplayProductColors
                                                            :colors="
                                                                product.colors
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-12 col-xl-12 product-custom-md-padding align-self-center text-center"
                                        v-show="
                                            product_list.length < 1 &&
                                            !isBusy &&
                                            hasSearched
                                        "
                                    >
                                        <div
                                            class="product mb-0 text-left"
                                            v-if="listConfig.searchKeyword"
                                        >
                                            <div class="span-20 last">
                                                <div
                                                    class="item_container_holder"
                                                >
                                                    <div class="title_holder">
                                                        <h2>
                                                            No Results Found
                                                        </h2>
                                                    </div>

                                                    <div
                                                        class="yCmsContentSlot item_container"
                                                    >
                                                        <div class="content">
                                                            <h2>
                                                                Sorry, we
                                                                couldn't find
                                                                any results for
                                                                your search
                                                            </h2>
                                                            <p>Suggestions:</p>
                                                            <ul class="pl_40">
                                                                <li>
                                                                    You may have
                                                                    typed your
                                                                    keywords
                                                                    incorrectly
                                                                    - please
                                                                    check for
                                                                    misspellings.
                                                                </li>
                                                                <li>
                                                                    You may have
                                                                    been too
                                                                    specific -
                                                                    please
                                                                    broaden your
                                                                    search by
                                                                    using fewer
                                                                    keywords.
                                                                </li>
                                                                <li>
                                                                    Browse our
                                                                    products by
                                                                    selecting a
                                                                    category
                                                                    above.
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="item_container"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="product mb-0 text-center"
                                            v-else
                                        >
                                            <h3>No results found.</h3>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="pagination_margin productlist_pagination_custom"
                                >
                                    <b-pagination
                                        v-show="category_length > itemsPerPage"
                                        v-model="currentPage"
                                        :total-rows="category_length"
                                        :per-page="itemsPerPage"
                                        class="imprint_pagination"
                                    ></b-pagination>
                                    <!-- <VPagination v-show="category_length > itemsPerPage" :pages="pages" :currentPage.sync="currentPage" /> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="preloader" v-show="isBusy">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            ></polygon>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
// import VPagination from "@/components/VPagination";
import DisplayProductColors from "@/components/DisplayProductColorsNew";
import DiscountOffer from "@/components/DiscountOfferNew";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
import ProductBottomLinks from "@/components/ProductBottomLinksNew";
// import DisplayProductImage from "@/components/DisplayProductImageNew";
import AttributeFilter from "@/components/AttributeFilter";
import { shouldApplyCapCategoryClass as shouldApplyCapCategoryClassService } from "@/common/capCategoryImage.service";

export default {
    name: "ProductList",
    components: {
        DisplayProductColors,
        DiscountOffer,
        DisplayProductPrice,
        // VPagination,
        ProductBottomLinks,
        // DisplayProductImage,
        AttributeFilter
    },
    data() {
        return {
            routeSlug: null,
            breadcrumb_names: [],
            breadcrumb_urls: [],
            sorting_array: [
                { label: "Relevance", value: "" },
                { label: "New", value: "new" },
                { label: "Price, High to Low", value: "price_desc" },
                { label: "Price, Low to High", value: "price_asc" },
                { label: "Name A to Z", value: "name_asc" },
                { label: "Name Z to A", value: "name_desc" }
            ],
            filter: null,
            isBusy: false,
            hasSearched: false, // Track if at least one search has completed
            isbrandShowMore: false,
            isstylesShowMore: false,
            iscolorsShowMore: false,
            issizesShowMore: false,
            ispricesShowMore: false,
            isattributesShowMore: false,
            iscolorShadesShowMore: false,
            prices: [
                { id: 1, from: 0, to: 9.99 },
                { id: 2, from: 10, to: 19.99 }
            ],
            prod_attr_ids: {
                color_shades: [],
                colors_ids: [],
                brands_ids: [],
                size_ids: [],
                styles_ids: []
            },
            category_list: [],
            selected_category: "",
            selected_second_category: "",
            product_list: [],
            brand_list: [],
            styles_list: [],
            gender_age_list: [],
            sleeve_list: [],
            style_category_list: [],
            fabric_list: [],
            color_list: [],
            color_shades_list: [],
            attribute_list: [],
            sizes_list: [],
            original_sizes_list: [],
            productTypeName: "Search",
            productTypePath: "/",
            applied_filters: [],
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                sizeIds: [],
                colorIds: [],
                colorShades: [],
                priceRanges: [],
                size_groupings: [],
                searchKeyword: "",
                attribute_options: [],
                pms: ""
            },
            listConfigCategory: {
                sortBy: "",
                order: "ASC",
                prod_type_id: this.$route.params.product_type,
                category_id: this.$route.params.first_filter_value
            },
            // category_length: 0,
            // currentPage: 1,
            category_length: this.$route.query.page
                ? this.$route.query.page * 20
                : 0,
            currentPage: this.$route.query.page ? this.$route.query.page : 1,
            itemsPerPage: 20,
            category_id: this.$route.params.first_filter_value,
            banner_image: null,
            price_range: 4.99,
            common_size_groups: [
                {
                    id: "XS-XL",
                    size: "XS-XL",
                    sizes: ["XS", "S", "M", "L", "XL"]
                },
                {
                    id: "7XL-10XL",
                    size: "7XL-10XL",
                    sizes: ["7XL", "8XL", "9XL", "10XL"]
                }
            ],
            shirt_sizes: [
                "XS-XL",
                "XS",
                "S",
                "M",
                "L",
                "XL",
                "XXL",
                "2XL",
                "3XL",
                "4XL",
                "5XL",
                "6XL",
                "7XL",
                "8XL",
                "9XL",
                "10XL",
                "7XL-10XL",
                "11XL",
                "12XL",
                "13XL",
                "14XL",
                "OSFM",
                "YXS",
                "YS",
                "YM",
                "YL",
                "YXL",
                "1T",
                "2T",
                "3T",
                "4T",
                "5T",
                "6T",
                "LT",
                "XLT",
                "2XLT",
                "3XLT",
                "4XLT"
            ],
            filters_count: {},
            query_attributes_loaded: false,
            all_colors_list: [],
            markup_tiers: []
        };
    },
    async beforeMount() {
        await this.getAllMarkupTiers();
    },
    async beforeRouteUpdate(to, from, next) {
        // Handle route updates when same component is reused (e.g., clicking navigation links)
        if (to.path !== from.path) {
            // Refresh menu data to get updated breadcrumbs
            try {
                await this.getSingleMenu();
                // Update title after router guard has run
                setTimeout(() => {
                    this.updatePageTitle();
                }, 100);
            } catch (error) {
                setTimeout(() => {
                    this.updatePageTitle();
                }, 100);
            }
        }
        next();
    },
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        this.onLoadPage();
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "printTemplates",
            "embroideryTemplates"
        ]),
        pages() {
            if (this.category_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(
                    Math.ceil(this.category_length / this.itemsPerPage)
                ).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getProducts();
        },
        isAuthenticatedClient(val) {
            if (val) {
                setTimeout(() => {
                    this.getAllFavoriteProducts();
                }, 100);
            }
        },
        breadcrumb_names: {
            handler(newVal, oldVal) {
                // console.log("in breadcrumb_names", newVal);
                // Only update if breadcrumb_names actually changed
                if (
                    newVal &&
                    newVal.length > 0 &&
                    (!oldVal ||
                        JSON.stringify(newVal) !== JSON.stringify(oldVal))
                ) {
                    // Use setTimeout to ensure this runs after router guard
                    setTimeout(() => {
                        this.updatePageTitle();
                    }, 50);
                }
            },
            immediate: true
        },
        $route: {
            handler(to, from) {
                // When route changes, refresh menu data to get updated breadcrumbs
                if (!from || to.path !== from.path) {
                    // Wait a bit to ensure route is fully updated
                    this.$nextTick(() => {
                        this.getSingleMenu()
                            .then(() => {
                                // Wait for breadcrumb_names to be set and router guard to complete
                                setTimeout(() => {
                                    // Double check breadcrumb_names is set before updating title
                                    if (
                                        this.breadcrumb_names &&
                                        this.breadcrumb_names.length > 0
                                    ) {
                                        this.updatePageTitle();
                                    }
                                }, 150);
                            })
                            .catch(() => {
                                // Still try to update title even if menu fetch fails
                                setTimeout(() => {
                                    if (
                                        this.breadcrumb_names &&
                                        this.breadcrumb_names.length > 0
                                    ) {
                                        this.updatePageTitle();
                                    }
                                }, 150);
                            });
                    });
                }
            },
            immediate: false,
            deep: true
        }
    },
    methods: {
        shouldApplyCapCategoryClass(categoryId, imageUrl) {
            return shouldApplyCapCategoryClassService(categoryId, imageUrl);
        },
        updatePageTitle() {
            // Set browser title to the first breadcrumb item (index 0)
            // Use setTimeout to ensure this runs after router guard sets title
            setTimeout(() => {
                if (this.breadcrumb_names && this.breadcrumb_names.length > 0) {
                    const firstBreadcrumb = this.breadcrumb_names[0];
                    // console.log("in updatePageTitle", firstBreadcrumb);
                    if (firstBreadcrumb) {
                        document.title = firstBreadcrumb;
                    }
                }
            }, 0);
        },
        async onLoadPage() {
            // Set loading state
            this.isBusy = true;
            this.hasSearched = false;

            // Run parallel operations for better performance
            // const [menuResult] = await Promise.all([
            //     this.getSingleMenu().catch(() => null), // Don't block if menu fails
            //     this.getAllColors()
            // ]);

            this.onloadPrepareQueryFilters();

            if (this.$route.params.product_type == "brand") {
                this.listConfig.category_id = "";
                this.listConfig.prod_type_id = "";
                this.listConfig.brand_id =
                    this.$route.params.first_filter_value;
                this.productTypeName = "Brands";
                this.productTypePath =
                    "/product-list/brand/" +
                    this.$route.params.first_filter_value;
            } else {
                this.productTypeName = "Search";
                this.productTypePath = "/product-list/all/all";
            }
            this.getProducts();
        },
        getProducts(pagereset = false, reloadFilterData = true) {
            var _this = this;
            _this.isBusy = true;
            new Promise((resolve, reject) => {
                if (pagereset) {
                    _this.currentPage = 1;
                    _this.listConfig.offset = 0;
                }
                if (_this.$route.params.first_filter_value != "all") {
                    _this.getSingleMenu();
                }

                let common_size_group_ids = _this.common_size_groups.map(
                    (size_group) => size_group.id
                );
                const params = JSON.parse(JSON.stringify(_this.listConfig));
                params["sizeIds"] = params["sizeIds"].filter(
                    (sizeId) => !common_size_group_ids.includes(sizeId)
                );

                // Set prod_type_id based on top-level menu if breadcrumb_names available
                if (
                    !params.prod_type_id &&
                    _this.breadcrumb_names &&
                    _this.breadcrumb_names.length > 0
                ) {
                    const menuProdTypeMap = {
                        apparel: 1,
                        bags: 2,
                        bag: 2,
                        hats: 3,
                        hat: 3,
                        promos: 1,
                        promo: 1,
                        events: 1,
                        event: 1
                    };

                    // First item in breadcrumb is the top-level menu
                    const topMenuSlug = _this.breadcrumb_names[0].toLowerCase();
                    if (menuProdTypeMap[topMenuSlug]) {
                        params.prod_type_id = menuProdTypeMap[topMenuSlug];
                    }
                }

                ApiService.post("/home-new-product-list", params)
                    .then(async ({ data }) => {
                        if (reloadFilterData) {
                            _this.selected_category = data.categories;
                        }
                        _this.category_length = data.products.count;
                        _this.product_list = data.products.rows;
                        _this.product_list = data.products.rows.filter(
                            (product) => product.MainNewSubProducts.length > 0
                        );

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.brandIds.length
                        ) {
                            this.prod_attr_ids["brands_ids"] = [];
                        }
                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.styles.length
                        ) {
                            this.prod_attr_ids["styles_ids"] = [];
                        }
                        this.filters_count["brands"] = {};
                        this.filters_count["styles"] = {};
                        this.filters_count["colorShades"] = {};
                        this.filters_count["colorShadeColors"] = {};
                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.sizeIds.length
                        ) {
                            this.prod_attr_ids["size_ids"] = [];
                        }
                        this.filters_count["sizes"] = {};
                        this.filters_count["priceRanges"] = {};
                        this.filters_count["attributes"] = {};

                        if (reloadFilterData) {
                            this.preparePriceRanges();
                        }

                        this.product_list.forEach((product) => {
                            product["default_color_id"] = null;
                            let sub_product = product.MainNewSubProducts.find(
                                (sub_product) => sub_product.default_selection
                            );
                            if (sub_product) {
                                product["default_color_id"] =
                                    sub_product.color_id;
                            }

                            let color_ids = product.color_ids
                                ? JSON.parse(product.color_ids)
                                : [];
                            product.colors = this.all_colors_list.filter(
                                (color) => color_ids.includes(color.id)
                            );

                            // Collect attribute IDs from products
                            this.getProductAttrIds(product);

                            // Keep PLP pricing source aligned with PDP:
                            // prefer default decoration service matrix from product.decorations.
                            let hasDefaultServiceMatrix = false;
                            if (product.decorations) {
                                try {
                                    const decorations =
                                        typeof product.decorations === "string"
                                            ? JSON.parse(product.decorations)
                                            : product.decorations;
                                    const serviceList =
                                        Array.isArray(decorations) &&
                                        decorations[0] &&
                                        Array.isArray(
                                            decorations[0].decoration_type_list
                                        )
                                            ? decorations[0].decoration_type_list
                                            : [];
                                    if (serviceList.length > 0) {
                                        const defaultService =
                                            serviceList.find(
                                                (service) =>
                                                    service &&
                                                    (service.is_default === 1 ||
                                                        service.is_default ===
                                                            true ||
                                                        service.is_default ===
                                                            "1")
                                            ) || serviceList[0];
                                        if (
                                            defaultService &&
                                            defaultService.price_decoration_bulk !=
                                                null &&
                                            defaultService.price_decoration_bulk !==
                                                ""
                                        ) {
                                            hasDefaultServiceMatrix = true;
                                        }
                                    }
                                } catch (e) {
                                    hasDefaultServiceMatrix = false;
                                }
                            }

                            if (
                                product.decoration_price_type == "global_price" &&
                                !hasDefaultServiceMatrix
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1 || product.decoration_type == 5) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });

                        this.prod_attr_ids["colors_ids"] = [
                            ...new Set(this.prod_attr_ids["colors_ids"])
                        ];
                        this.prod_attr_ids["size_ids"] = [
                            ...new Set(this.prod_attr_ids["size_ids"])
                        ];
                        this.prod_attr_ids["styles_ids"] = [
                            ...new Set(this.prod_attr_ids["styles_ids"])
                        ];

                        if (this.isAuthenticatedClient) {
                            this.getAllFavoriteProducts();
                        }

                        this.prices.forEach((price) => {
                            price.products_count =
                                this.filters_count["priceRanges"][price.id] ||
                                0;
                        });

                        if (
                            this.selected_category &&
                            this.selected_category.Attributes
                        ) {
                            let attributes = JSON.parse(
                                JSON.stringify(
                                    this.selected_category.Attributes
                                )
                            );
                            attributes.forEach((attribute) => {
                                if (attribute.AttributeOptions) {
                                    attribute.AttributeOptions.forEach(
                                        (option) => {
                                            if (
                                                this.filters_count["attributes"]
                                            ) {
                                                option.products_count =
                                                    this.filters_count[
                                                        "attributes"
                                                    ][option.id] || 0;
                                            }
                                        }
                                    );
                                }
                            });
                            this.selected_category.Attributes = attributes;
                        }

                        _this.isBusy = false;
                        _this.hasSearched = true; // Mark that search has completed

                        await _this.getAllFilterValues();

                        if (!_this.query_attributes_loaded) {
                            _this.onloadPrepareQueryAppliedFacets();
                        }
                        _this.prepareQueryParamsOnRoute();

                        _this.query_attributes_loaded = true;
                        resolve(data);
                    })
                    .catch((response) => {
                        _this.isBusy = false;
                        _this.hasSearched = true; // Mark search as completed even on error
                        reject(response);
                    });
            });
        },
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },
        getSingleMenu() {
            let params = {
                url: this.$route.path,
                // slug: this.$route.params.product_type,
                sub_item_id: this.$route.params.first_filter_value
            };
            // if (this.$route.params.filter_text) {
            //     if (this.$route.params.filter == "styles") {
            //         params["nest_item_name"] = this.$route.params.filter_text;
            //     } else {
            //         params["nest_item_id"] = this.$route.params.filter_text;
            //     }
            // }
            return new Promise((resolve, reject) => {
                ApiService.post("/get-single-menu-by-url", params)
                    .then(({ data }) => {
                        // console.log("in getSingleMenu", data.menu_data);
                        if (data.menu_data) {
                            this.listConfig.prod_type_id = data.menu_data.id;
                            this.listConfigCategory.prod_type_id =
                                this.listConfig.prod_type_id;
                            this.productTypePath = data.menu_data.url;
                            this.productTypeName = data.menu_data.slug;
                            this.breadcrumb_names = data.breadcrumb_names;
                            this.breadcrumb_urls = data.breadcrumb_urls;

                            // Update browser title based on breadcrumb (first item)
                            // Use setTimeout to ensure this runs after router guard sets title
                            setTimeout(() => {
                                this.updatePageTitle();
                            }, 100);

                            // Get top-level menu slug from breadcrumb (first item is top-level)
                            let topMenuSlug = null;
                            if (
                                data.breadcrumb_names &&
                                data.breadcrumb_names.length > 0
                            ) {
                                // First item in breadcrumb is the top-level menu
                                topMenuSlug =
                                    data.breadcrumb_names[0].toLowerCase();
                            } else if (data.menu_data && data.menu_data.slug) {
                                // If no breadcrumb, use current menu slug (might be top-level)
                                topMenuSlug = data.menu_data.slug.toLowerCase();
                            }

                            // Map menu slug to prod_type_id: Apparel=1, Bags=2, Hats=3, Promos=4, Events=5
                            if (topMenuSlug) {
                                const menuProdTypeMap = {
                                    apparel: 1,
                                    bags: 2,
                                    bag: 2,
                                    hats: 3,
                                    hat: 3,
                                    promos: 1,
                                    promo: 1,
                                    events: 1,
                                    event: 1
                                };

                                if (menuProdTypeMap[topMenuSlug]) {
                                    this.listConfig.prod_type_id =
                                        menuProdTypeMap[topMenuSlug];
                                    this.listConfigCategory.prod_type_id =
                                        this.listConfig.prod_type_id;
                                }
                            }

                            if (this.$route.params.filter_text) {
                                this.banner_image = data.nest_menu_data
                                    ? data.nest_menu_data.banner_image
                                    : null;
                            } else {
                                this.banner_image = data.sub_menu_data
                                    ? data.sub_menu_data.banner_image
                                    : null;
                            }
                        }
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        showMore(attribute) {
            if (typeof attribute == "string") {
                this[attribute] = this[attribute] ? false : true;
                return;
            } else {
                attribute.show_more = attribute.show_more ? false : true;
            }
            this.$forceUpdate();
        },
        CategoryTitle(categories) {
            if (this.$route.params.product_type == "all") {
                let searchValue = this.listConfig.searchKeyword
                    ? 'Search-"' + this.listConfig.searchKeyword + '"'
                    : " ";
                return searchValue;
            }
            if (this.$route.params.product_type == "brand") {
                let brand = this.brand_list.find(
                    (element) =>
                        element.id == this.$route.params.first_filter_value
                );
                return brand ? brand.name : "";
            }
            return categories ? categories : "";
        },
        CategoryBreadcrumbs(categories) {
            if (this.$route.params.product_type == "all") {
                let searchValue = this.listConfig.searchKeyword
                    ? this.listConfig.searchKeyword
                    : " ";
                return searchValue;
            }
            if (this.$route.params.product_type == "brand") {
                let brand = this.brand_list.find(
                    (element) =>
                        element.id == this.$route.params.first_filter_value
                );
                return brand ? brand.name : "";
            }
            return categories ? categories.title : "";
        },
        getAllFilterValues() {
            const categoryIdFromUrl = this.breadcrumb_urls[0]
                ? this.breadcrumb_urls[0].split("/").pop()
                : null;
            var _this = this;
            return new Promise((resolve, reject) => {
                ApiService.post("/get-product-attributes", {
                    category_id: categoryIdFromUrl,
                    prod_attr_ids: _this.prod_attr_ids
                })
                    .then(({ data }) => {
                        if (this.selected_category) {
                            const attributesWithCounts = (
                                data.attributes || []
                            ).map((attribute) => ({
                                ...attribute,
                                show_more: attribute.show_more || false,
                                AttributeOptions: (
                                    attribute.AttributeOptions || []
                                ).map((option) => ({
                                    ...option,
                                    products_count:
                                        (this.filters_count["attributes"] || {})[
                                            option.id
                                        ] || 0
                                }))
                            }));
                            this.$set(
                                this.selected_category,
                                "Attributes",
                                attributesWithCounts
                            );
                        }
                        _this.brand_list = data.brands;
                        _this.brand_list.forEach((brand) => {
                            delete brand.colors;
                            brand.products_count =
                                this.filters_count["brands"][brand.id] || 0;
                        });
                        _this.styles_list = data.styles;
                        _this.styles_list.forEach((style) => {
                            style.products_count =
                                this.filters_count["styles"][style.id] || 0;
                        });
                        _this.color_list = data.colors;
                        _this.color_shades_list = [];
                        _this.color_list.forEach((color) => {
                            if (color && color.shades) {
                                let shades = color.shades
                                    ? JSON.parse(color.shades)
                                    : [];
                                shades.forEach((shadeName) => {
                                    const index =
                                        this.color_shades_list.findIndex(
                                            (shade) => shade.name == shadeName
                                        );
                                    if (index == -1) {
                                        this.color_shades_list.push({
                                            id:
                                                this.color_shades_list.length +
                                                1,
                                            name: shadeName,
                                            products_count: 0,
                                            colors: [color]
                                        });
                                    } else {
                                        const color_index =
                                            this.color_shades_list[
                                                index
                                            ].colors.findIndex(
                                                (colorObj) =>
                                                    colorObj.id == color.id
                                            );
                                        if (color_index == -1) {
                                            this.color_shades_list[
                                                index
                                            ].colors.push(color);
                                        }
                                    }
                                });
                            }
                        });

                        _this.sizes_list = [];
                        let sizes_list = data.sizes;
                        _this.original_sizes_list = data.sizes;
                        const sorted_size_names = _this.sizesArrangmentSorting(
                            sizes_list.map((size) => size.size)
                        );
                        let sorted_size_objs = [];
                        sorted_size_names.forEach((sorted_size_name) => {
                            sizes_list.forEach((random_size) => {
                                if (random_size.size == sorted_size_name) {
                                    sorted_size_objs.push(random_size);
                                }
                            });
                        });
                        sorted_size_objs.forEach((size) => {
                            const common_size_group =
                                this.common_size_groups.find((size_group) =>
                                    size_group.sizes.includes(size.size)
                                );
                            if (common_size_group) {
                                const index = _this.sizes_list.findIndex(
                                    (size) => size.id == common_size_group.id
                                );
                                if (index == -1) {
                                    _this.sizes_list.push(common_size_group);
                                }
                            } else {
                                _this.sizes_list.push(size);
                            }
                        });

                        _this.sizes_list.forEach((size) => {
                            size.products_count = 0;
                            if (size.sizes) {
                                let original_size_ids = data.sizes
                                    .filter((sizes) =>
                                        size.sizes.includes(sizes.size)
                                    )
                                    .map((sizeData) => sizeData.id);
                                let product_ids = [];
                                original_size_ids.forEach((id) => {
                                    product_ids = product_ids.concat(
                                        this.filters_count["sizes"][id] || []
                                    );
                                });
                                product_ids = [...new Set(product_ids)];
                                size.products_count = product_ids.length;
                            } else {
                                if (this.filters_count["sizes"][size.id]) {
                                    size.products_count =
                                        this.filters_count["sizes"][size.id]
                                            .length || 0;
                                }
                            }
                        });

                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getColors(colors) {
            this.color_list = [];
            colors.forEach((color) => {
                this.color_list.push({
                    color_name: this.upperCaseFirst(color.name),
                    hash: color.hex,
                    swatches: color.swatches
                });
            });
            this.color_list = this.color_list
                .filter(
                    (item, pos, self) =>
                        self.findIndex((v) => v.hex === item.hex) === pos
                )
                .sort((a, b) => (a.name > b.name ? 1 : -1));
        },
        upperCaseFirst(str) {
            return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
        },
        productImage(images) {
            return images[0]
                ? images[0].image_path
                : "/maincss/images/featured_product_1.png";
        },
        clearFilters(type = "all", id = null) {
            if (type == "all") {
                this.applied_filters.forEach((filter) => {
                    this.listConfig[filter.config_type] = [];
                });
                this.listConfig["colorIds"] = [];
                this.listConfig["pms"] = "";
                this.applied_filters = [];
            } else if (type == "attribute_options") {
                const removableOptionIds = this.applied_filters
                    .filter((filter) => filter.attribute_id == id)
                    .map((filter) => filter.option_id);
                this.listConfig[type] = this.listConfig[type].filter(
                    (filterId) => !removableOptionIds.includes(filterId)
                );
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            } else if (type == "colorShades") {
                this.listConfig[type] = [];
                this.listConfig["colorIds"] = [];
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            } else {
                this.listConfig[type] = [];
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            }
            this.getProducts(true, type == "all");
        },
        removeAppliedFilters(filter) {
            this.applied_filters = this.applied_filters.filter(
                (appliedFilter) =>
                    !(
                        appliedFilter.attribute_id == filter.attribute_id &&
                        filter.option_id == appliedFilter.option_id
                    )
            );
            if (filter.config_type == "priceRanges") {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((config) => config.id != filter.option_id);
            } else if (filter.config_type == "colorShades") {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
                let shade = this.color_shades_list.find(
                    (shade) => shade.name == filter.option_id
                );
                let unchecked_shade_colors = shade.colors.map(
                    (color) => color.id
                );
                this.listConfig["colorIds"] = this.listConfig[
                    "colorIds"
                ].filter(
                    (colorId) =>
                        !unchecked_shade_colors.includes(parseInt(colorId))
                );
            } else if (filter.config_type == "sizeIds") {
                const common_size_group = this.common_size_groups.find(
                    (size_group) => size_group.id == filter.option_id
                );
                if (common_size_group) {
                    let size_ids = this.original_sizes_list
                        .filter((size) =>
                            common_size_group.sizes.includes(size.size)
                        )
                        .map((size) => size.id);
                    this.listConfig[filter.config_type] = this.listConfig[
                        filter.config_type
                    ].filter((sizeId) => !size_ids.includes(sizeId));
                }
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
            } else if (filter.config_type == "pms") {
                this.listConfig[filter.config_type] = "";
            } else {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
            }
            this.getProducts(true, false);
        },
        filterProducts(event, value, type, attributeId, option_label) {
            if (type == "priceRanges") {
                if (event.target.checked == true) {
                    this.listConfig[type].push(value);
                    this.applied_filters.push({
                        option_id: value.id,
                        config_type: type,
                        attribute_id: attributeId,
                        option_label: `$${value.from} - $${value.to}`
                    });
                } else {
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option.id != value.id
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value.id == filter.option_id
                            )
                    );
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            } else if (type == "sizeIds") {
                const common_size_group = this.common_size_groups.find(
                    (size_group) => size_group.size == value
                );
                if (event.target.checked == true) {
                    if (common_size_group) {
                        let size_ids = this.original_sizes_list
                            .filter((size) =>
                                common_size_group.sizes.includes(size.size)
                            )
                            .map((size) => size.id);
                        this.listConfig[type] =
                            this.listConfig[type].concat(size_ids);
                    }
                    this.listConfig[type].push(value);
                    this.applied_filters.push({
                        option_id: value,
                        config_type: type,
                        attribute_id: attributeId,
                        option_label
                    });
                } else {
                    if (common_size_group) {
                        let size_ids = this.original_sizes_list
                            .filter((size) =>
                                common_size_group.sizes.includes(size.size)
                            )
                            .map((size) => size.id);
                        this.listConfig[type] = this.listConfig[type].filter(
                            (sizeId) => !size_ids.includes(sizeId)
                        );
                    }
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option != value
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value == filter.option_id
                            )
                    );
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            } else if (type == "pms") {
                let filter_index = this.applied_filters.findIndex(
                    (filter) => filter.config_type == "pms"
                );
                if (event.target.checked == true) {
                    if ((!value || !value.trim()) && filter_index >= 0) {
                        this.removeAppliedFilters(
                            this.applied_filters[filter_index]
                        );
                        return;
                    } else if (
                        (!value || !value.trim()) &&
                        filter_index == -1
                    ) {
                        return;
                    }

                    if (filter_index >= 0) {
                        this.applied_filters[filter_index]["option_label"] =
                            value.trim();
                    } else {
                        this.applied_filters.push({
                            option_id: "pms",
                            config_type: "pms",
                            attribute_id: "pms",
                            option_label: value.trim()
                        });
                    }
                    this.listConfig[type] = value.trim();
                } else {
                    this.removeAppliedFilters(
                        this.applied_filters[filter_index]
                    );
                }
            } else {
                if (event.target.checked == true) {
                    if (!this.listConfig[type].includes(value)) {
                        this.listConfig[type].push(value);
                    }
                    if (
                        !this.applied_filters.find(
                            (filter) => filter.option_id == value
                        )
                    ) {
                        this.applied_filters.push({
                            option_id: value,
                            config_type: type,
                            attribute_id: attributeId,
                            option_label
                        });
                    }
                    if (type == "colorShades") {
                        if (this.listConfig["colorIds"].length == 0) {
                            let shade = this.color_shades_list.find(
                                (shade) => shade.name == value
                            );
                            let shade_color_ids = shade.colors.map(
                                (color) => color.id
                            );
                            this.listConfig["colorIds"] = [
                                ...new Set(
                                    this.listConfig["colorIds"].concat(
                                        shade_color_ids
                                    )
                                )
                            ];
                        }
                    }
                } else {
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option != value
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value == filter.option_id
                            )
                    );
                    if (type == "colorShades") {
                        let shade = this.color_shades_list.find(
                            (shade) => shade.name == value
                        );
                        let unchecked_shade_colors = shade.colors.map(
                            (color) => color.id
                        );
                        this.listConfig["colorIds"] = this.listConfig[
                            "colorIds"
                        ].filter(
                            (colorId) =>
                                !unchecked_shade_colors.includes(
                                    parseInt(colorId)
                                )
                        );
                    }
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            }
            this.getProducts(true, false);
        },
        getProductAttrIds(product) {
            if (
                !this.query_attributes_loaded ||
                (!this.listConfig.brandIds.length &&
                    !this.prod_attr_ids["brands_ids"].includes(
                        product.brand_id
                    ))
            ) {
                this.prod_attr_ids["brands_ids"].push(product.brand_id);
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.colorShades.length
            ) {
                product.MainNewSubProducts.forEach((subProduct) => {
                    if (subProduct.Color && subProduct.Color.shades) {
                        let shades = subProduct.Color.shades
                            ? JSON.parse(subProduct.Color.shades)
                            : [];
                        shades.forEach((shadeName) => {
                            const index = this.color_shades_list.findIndex(
                                (shade) => shade.name == shadeName
                            );
                            if (
                                this.filters_count["colorShadeColors"] &&
                                this.filters_count["colorShadeColors"][
                                    shadeName
                                ]
                            ) {
                                subProduct.Color.products_count =
                                    this.filters_count["colorShadeColors"][
                                        shadeName
                                    ][subProduct.color_id] || 0;
                            }
                            if (index == -1) {
                                this.color_shades_list.push({
                                    id: this.color_shades_list.length + 1,
                                    name: shadeName,
                                    products_count:
                                        this.filters_count["colorShades"][
                                            shadeName
                                        ] || 0,
                                    colors: [subProduct.Color]
                                });
                            } else {
                                const color_index = this.color_shades_list[
                                    index
                                ].colors.findIndex(
                                    (color) => color.id == subProduct.color_id
                                );
                                if (color_index == -1) {
                                    this.color_shades_list[index].colors.push(
                                        subProduct.Color
                                    );
                                }
                            }
                        });
                    }
                });
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.sizeIds.length
            ) {
                this.prod_attr_ids["size_ids"] = this.prod_attr_ids[
                    "size_ids"
                ].concat(
                    product.MainNewSubProducts.map(
                        (sub_product) => sub_product.size_id
                    )
                );
            }

            // Collect styles from products
            if (
                !this.query_attributes_loaded ||
                !this.listConfig.styles ||
                !this.listConfig.styles.length
            ) {
                if (product.styles) {
                    let styles = [];
                    try {
                        styles = JSON.parse(product.styles);
                    } catch (e) {
                        styles = [];
                    }
                    if (Array.isArray(styles) && styles.length > 0) {
                        styles.forEach((styleId) => {
                            if (
                                styleId &&
                                !this.prod_attr_ids["styles_ids"].includes(
                                    styleId
                                )
                            ) {
                                this.prod_attr_ids["styles_ids"].push(styleId);
                            }
                        });
                    }
                }
            }
        },
        preparePriceRanges() {
            let highestPrice = 0;
            this.product_list.forEach((product) => {
                if (
                    parseFloat(highestPrice) <
                    parseFloat(product.lowest_base_price)
                ) {
                    highestPrice = parseFloat(product.lowest_base_price) + 1;
                }
            });
            if (!this.listConfig.priceRanges.length) {
                let priceRanges = [];
                let currentRange = 0;
                const rangeSize = this.price_range;

                let i = 0;
                while (currentRange < highestPrice) {
                    const rangeStart = currentRange;
                    const rangeEnd = Math.min(
                        currentRange + rangeSize,
                        highestPrice
                    );
                    priceRanges.push({
                        id: i + 1,
                        from: parseFloat(rangeStart).toFixed(2),
                        to: parseFloat(rangeEnd).toFixed(2)
                    });
                    currentRange += rangeSize + 0.01;
                    i++;
                }
                this.prices = priceRanges;
            }
        },
        prepareFiltersCount() {
            this.product_list.forEach((product) => {
                // BRAND COUNT
                // if (!this.query_attributes_loaded || !this.listConfig.brandIds.length) {

                if (!this.filters_count["brands"]) {
                    this.filters_count["brands"] = { [product.brand_id]: 1 };
                } else if (!this.filters_count["brands"][product.brand_id]) {
                    this.filters_count["brands"][product.brand_id] = 1;
                } else {
                    this.filters_count["brands"][product.brand_id]++;
                }
                // STYLES COUNT
                if (product.style_id) {
                    if (!this.filters_count["styles"]) {
                        this.filters_count["styles"] = {
                            [product.style_id]: 1
                        };
                    } else if (
                        !this.filters_count["styles"][product.style_id]
                    ) {
                        this.filters_count["styles"][product.style_id] = 1;
                    } else {
                        this.filters_count["styles"][product.style_id]++;
                    }
                }
                // }

                // COLOR SHADES COUNT
                // if (!this.query_attributes_loaded || !this.listConfig.colorShades.length) {
                let color_shades = [];
                product.MainNewSubProducts.forEach((subProduct) => {
                    if (subProduct.Color && subProduct.Color.shades) {
                        let shades = subProduct.Color.shades
                            ? JSON.parse(subProduct.Color.shades)
                            : [];
                        color_shades = color_shades.concat(shades);
                    }
                });

                // let color_shades = product.NewSubProducts.map(subProduct =>subProduct.Color.shades).filter(n =>n);
                color_shades = [...new Set(color_shades)];
                color_shades.forEach((shade) => {
                    if (!this.filters_count["colorShades"]) {
                        this.filters_count["colorShades"] = { [shade]: 1 };
                    } else if (!this.filters_count["colorShades"][shade]) {
                        this.filters_count["colorShades"][shade] = 1;
                    } else {
                        this.filters_count["colorShades"][shade]++;
                    }

                    let color_ids = product.MainNewSubProducts.filter(
                        (subProduct) =>
                            subProduct.Color && subProduct.Color.shades == shade
                    ).map((subProduct) => subProduct.color_id);
                    color_ids = [...new Set(color_ids)];

                    color_ids.forEach((colorId) => {
                        if (!this.filters_count["colorShadeColors"]) {
                            this.filters_count["colorShadeColors"] = {
                                [shade]: { [colorId]: 1 }
                            };
                        } else if (
                            !this.filters_count["colorShadeColors"][shade]
                        ) {
                            this.filters_count["colorShadeColors"][shade] = {
                                [colorId]: 1
                            };
                        } else if (
                            !this.filters_count["colorShadeColors"][shade][
                                colorId
                            ]
                        ) {
                            this.filters_count["colorShadeColors"][shade][
                                colorId
                            ] = 1;
                        } else {
                            this.filters_count["colorShadeColors"][shade][
                                colorId
                            ]++;
                        }
                    });
                });
                // }

                // SIZES COUNT
                // if (!this.query_attributes_loaded || !this.listConfig.sizeIds.length) {
                let sizes = product.MainNewSubProducts.map(
                    (subProduct) => subProduct.size_id
                );
                sizes = [...new Set(sizes)];
                sizes.forEach((size) => {
                    if (!this.filters_count["sizes"]) {
                        this.filters_count["sizes"] = { [size]: [product.id] };
                    } else if (!this.filters_count["sizes"][size]) {
                        this.filters_count["sizes"][size] = [product.id];
                    } else {
                        this.filters_count["sizes"][size].push(product.id);
                    }
                });
                // }

                // PRICE RANGES COUNT
                // if (!this.query_attributes_loaded || !this.listConfig.priceRanges.length) {
                this.prices.forEach((priceRange) => {
                    if (
                        parseFloat(product.lowest_base_price) >=
                            parseFloat(priceRange.from) &&
                        parseFloat(product.lowest_base_price) <=
                            parseFloat(priceRange.to)
                    ) {
                        if (!this.filters_count["priceRanges"]) {
                            this.filters_count["priceRanges"] = {
                                [priceRange.id]: 1
                            };
                        } else if (
                            !this.filters_count["priceRanges"][priceRange.id]
                        ) {
                            this.filters_count["priceRanges"][
                                priceRange.id
                            ] = 1;
                        } else {
                            this.filters_count["priceRanges"][priceRange.id]++;
                        }
                    }
                });
                // }

                // ATTRIBUTES COUNT
                // if (!this.query_attributes_loaded || !this.listConfig.attribute_options.length) {
                if (product.ProductAttribute) {
                    const attributeOptions = JSON.parse(
                        product.ProductAttribute.attribute_options
                    );
                    attributeOptions.forEach((optionId) => {
                        if (!this.filters_count["attributes"]) {
                            this.filters_count["attributes"] = {
                                [optionId]: 1
                            };
                        } else if (
                            !this.filters_count["attributes"][optionId]
                        ) {
                            this.filters_count["attributes"][optionId] = 1;
                        } else {
                            this.filters_count["attributes"][optionId]++;
                        }
                    });
                }
                // }
            });
        },
        queryParams(config) {
            let colorShades = config.colorShades
                ? config.colorShades.map((shade) => this.toSnakeCase(shade))
                : [];
            let priceRanges = config.priceRanges
                ? config.priceRanges.map((range) => `${range.from}_${range.to}`)
                : [];
            let updatedParams = {
                attributes: config.attribute_options.join(",") || undefined,
                brands: config.brandIds.join(",") || undefined,
                sizes: config.sizeIds.join(",") || undefined,
                colorShades: colorShades.join(",") || undefined,
                colors: config.colorIds.join(",") || undefined,
                prices: priceRanges.join(",") || undefined,
                pms: config.pms || undefined,
                page: this.currentPage || undefined
            };

            updatedParams = this.removeEmptyKeys(updatedParams);

            return updatedParams;
        },
        prepareQueryParamsOnRoute() {
            const currentRoute = { ...this.$router.currentRoute }; // Copy the current route object
            currentRoute.query = { ...currentRoute.query };
            let updatedParams = this.queryParams(this.listConfig);

            const hasDifferentQueryParams =
                JSON.stringify(currentRoute.query) !==
                JSON.stringify(updatedParams);
            if (hasDifferentQueryParams) {
                currentRoute.query = updatedParams;
                this.$router.replace(currentRoute);
            }
        },
        onloadPrepareQueryFilters() {
            let queryParams = this.$route.query;

            let routeBrands = queryParams.brands
                ? queryParams.brands.split(",")
                : [];
            routeBrands = routeBrands.map((attrOption) => parseInt(attrOption));
            let routeStyles = queryParams.styles
                ? queryParams.styles.split(",")
                : [];
            routeStyles = routeStyles.map((attrOption) => parseInt(attrOption));
            let routeColorShades = queryParams.colorShades
                ? queryParams.colorShades.split(",")
                : [];
            routeColorShades = routeColorShades.map((attrOption) =>
                this.toTitleCase(attrOption)
            );

            let routeColors = queryParams.colors
                ? queryParams.colors.split(",")
                : [];
            routeColors = routeColors.map((attrOption) => parseInt(attrOption));

            let routeSizes = queryParams.sizes
                ? queryParams.sizes.split(",")
                : [];
            routeSizes = routeSizes.map((attrOption) =>
                !parseInt(attrOption) ? attrOption : parseInt(attrOption)
            );

            let routePrices = queryParams.prices
                ? queryParams.prices.split(",")
                : [];
            routePrices = routePrices.map((price) => ({
                from: parseFloat(price.split("_")[0]),
                to: parseFloat(price.split("_")[1])
            }));

            let routeAttributeOptions = queryParams.attributes
                ? queryParams.attributes.split(",")
                : [];
            routeAttributeOptions = routeAttributeOptions.map((attrOption) =>
                parseInt(attrOption)
            );

            let routePMS = queryParams.pms || "";

            var _this = this;
            _this.listConfig = {
                offset: (_this.currentPage - 1) * _this.itemsPerPage,
                limit: _this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: routeBrands,
                styles: routeStyles,
                size_groupings: [],
                colorNames: [],
                sizeIds: routeSizes,
                colorIds: routeColors,
                colorShades: routeColorShades,
                pms: routePMS,
                prod_type_id: _this.$route.params.product_type,
                first_filter_name: _this.$route.params.first_filter_name,
                first_filter_value: _this.$route.params.first_filter_value,
                second_filter_name: _this.$route.params.second_filter_name,
                second_filter_value: _this.$route.params.second_filter_value,
                priceRanges: routePrices,
                sorting: "",
                attribute_options: routeAttributeOptions
            };
        },
        onloadPrepareQueryAppliedFacets() {
            this.applied_filters = [];

            let queryParams = this.$route.query;

            let routeBrands = queryParams.brands
                ? queryParams.brands.split(",")
                : [];
            routeBrands = routeBrands.map((attrOption) => parseInt(attrOption));
            routeBrands.forEach((brandId) => {
                let brand = this.brand_list.find(
                    (brand) => brand.id == parseInt(brandId)
                );
                if (brand) {
                    this.applied_filters.push({
                        attribute_id: "Brands",
                        config_type: "brandIds",
                        option_id: brandId,
                        option_label: brand.name
                    });
                }
            });
            let routeStyles = queryParams.styles
                ? queryParams.styles.split(",")
                : [];
            routeStyles = routeStyles.map((attrOption) => parseInt(attrOption));
            routeStyles.forEach((styleId) => {
                let style = this.styles_list.find(
                    (style) => style.id == styleId
                );
                if (style) {
                    this.applied_filters.push({
                        attribute_id: "Styles",
                        config_type: "styles",
                        option_id: styleId,
                        option_label: style.name
                    });
                }
            });
            let routeColorShades = queryParams.colorShades
                ? queryParams.colorShades.split(",")
                : [];
            routeColorShades = routeColorShades.map((attrOption) =>
                this.toTitleCase(attrOption)
            );
            routeColorShades.forEach((colorShade) => {
                let shade = this.color_shades_list.find(
                    (shade) => shade.name == colorShade
                );
                if (shade) {
                    this.applied_filters.push({
                        attribute_id: "ColorShades",
                        config_type: "colorShades",
                        option_id: colorShade,
                        option_label: shade.name
                    });
                }
            });

            let routeSizes = queryParams.sizes
                ? queryParams.sizes.split(",")
                : [];
            routeSizes = routeSizes.map((attrOption) =>
                !parseInt(attrOption) ? attrOption : parseInt(attrOption)
            );
            routeSizes.forEach((sizeId) => {
                let size = this.sizes_list.find((size) => size.id == sizeId);
                if (size) {
                    this.applied_filters.push({
                        attribute_id: "Sizes",
                        config_type: "sizeIds",
                        option_id: sizeId,
                        option_label: size.size
                    });
                }
            });

            let routePrices = queryParams.prices
                ? queryParams.prices.split(",")
                : [];
            routePrices = routePrices.map((price) => ({
                from: parseFloat(price.split("_")[0]),
                to: parseFloat(price.split("_")[1])
            }));
            routePrices.forEach((price) => {
                let priceRange = this.prices.findIndex(
                    (currentprice) => currentprice.to == price.to
                );
                if (priceRange >= 0) {
                    this.applied_filters.push({
                        attribute_id: "Prices",
                        config_type: "priceRanges",
                        option_id: priceRange,
                        option_label: `$${price.from} - $${price.to}`
                    });
                }
            });

            let routeAttributeOptions = queryParams.attributes
                ? queryParams.attributes.split(",")
                : [];
            routeAttributeOptions = routeAttributeOptions.map((attrOption) =>
                parseInt(attrOption)
            );
            if (this.selected_category && this.selected_category.Attributes) {
                this.selected_category.Attributes.forEach((attr) => {
                    if (attr.AttributeOptions) {
                        attr.AttributeOptions.forEach((option) => {
                            if (routeAttributeOptions.includes(option.id)) {
                                this.applied_filters.push({
                                    attribute_id: `Attribute-${attr.id}`,
                                    config_type: "attribute_options",
                                    option_id: option.id,
                                    option_label: option.category
                                });
                            }
                        });
                    }
                });
            }

            let routePMS = queryParams.pms || null;
            if (routePMS) {
                this.applied_filters.push({
                    attribute_id: "pms",
                    config_type: "pms",
                    option_id: "pms",
                    option_label: routePMS
                });
            }
        },
        getCategories() {
            var _this = this;
            new Promise((resolve, reject) => {
                ApiService.post(
                    "/home-new-product-type-categories",
                    _this.listConfigCategory
                )
                    .then(({ data }) => {
                        _this.category_list = data.categories.rows;
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllFavoriteProducts() {
            let product_list_ids = this.product_list.map(
                (product) => product.id
            );
            ApiService.post("/get-favorite-by-product-ids", {
                ids: product_list_ids
            })
                .then(({ data }) => {
                    let favourite_product_ids = data.favorite.map(
                        (product) => product.product_id
                    );
                    this.product_list.forEach((product) => {
                        this.$refs[
                            `bottom-links-${product.id}`
                        ][0].is_favorite_product =
                            favourite_product_ids.includes(product.id);
                        this.$refs[
                            `bottom-links-${product.id}`
                        ][0].favorite_product = data.favorite.find(
                            (fav) => fav.product_id == product.id
                        );
                    });
                })
                .catch((response) => {
                    console.log(response);
                });
        },
        updatePageUrl() {
            let searchKeyword = this.listConfig.searchKeyword;

            const currentRoute = { ...this.$router.currentRoute }; // Copy the current route object
            currentRoute.query = { ...currentRoute.query };
            searchKeyword ? (currentRoute.query.q = searchKeyword) : "";
            this.currentPage > 1
                ? (currentRoute.query.page = this.currentPage)
                : "";
            this.sortBy ? (currentRoute.query.sort_by = this.sortBy) : "";

            var currentUrl = window.location.pathname;
            this.$router.push({ path: currentUrl, query: currentRoute.query });
        },
        getRetailPrice(product) {
            let product_cost = product.price_base;
            let markup_value = product.price_markup_value;
            let price_color_category_dark = product.price_color_category_dark;
            let price_color_category_light = product.price_color_category_light;
            let single_location_cost = 0;
            if (product.decoration_flag == 1) {
                if (product.decoration_type == 1 || product.decoration_type == 5) {
                    let decoration_prices = JSON.parse(
                        product.price_decoration_bulk
                    )["print_location1"];
                    decoration_prices.forEach((decoration, i) => {
                        if (i == 0) {
                            single_location_cost = decoration.colour1;
                        } else if (
                            parseFloat(single_location_cost) >
                            parseFloat(decoration.colour1)
                        ) {
                            single_location_cost = decoration.colour1;
                        }
                    });
                } else {
                    let decoration_prices = JSON.parse(
                        product.price_decoration_bulk
                    );
                    decoration_prices.forEach((decoration, i) => {
                        if (i == 0) {
                            single_location_cost = decoration.cost;
                        } else if (
                            parseFloat(single_location_cost) >
                            parseFloat(decoration.cost)
                        ) {
                            single_location_cost = decoration.cost;
                        }
                    });
                }
            }
            let retail_price = parseFloat(
                parseFloat(product_cost) +
                    parseFloat(markup_value) +
                    parseFloat(price_color_category_dark) +
                    parseFloat(price_color_category_light) +
                    parseFloat(single_location_cost)
            ).toFixed(2);
            if (isNaN(retail_price)) {
                retail_price = 0.0;
            }
            return retail_price;
        },
        sizesArrangmentSorting(all_sizes) {
            var all_product_sizes = JSON.parse(
                JSON.stringify(this.shirt_sizes)
            );
            all_sizes.forEach((size) => {
                if (!all_product_sizes.includes(size)) {
                    all_product_sizes.push(size);
                }
            });

            var ar1 = all_product_sizes;
            var ar2 = all_sizes;

            var tmpar = [];
            for (var i = 0; i < ar1.length; i++) {
                if (ar2.indexOf(ar1[i]) !== -1) {
                    tmpar.push(ar1[i]);
                }
            }
            ar1 = tmpar;
            return ar1;
        },
        getAllColors() {
            return new Promise((resolve, reject) => {
                ApiService.post("/all-colors", {
                    attributes: ["id", "name", "hex", "swatches", "category"]
                })
                    .then(({ data }) => {
                        this.all_colors_list = data.colors;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    }
};
</script>
<style>
.pro_img_fluid {
    margin: 0 auto;
    display: block;
}
.cap_category_images{
    max-width: revert-layer;
}
</style>
